import React, { Component } from 'react';
import { Button, Input, Required } from '../../utils/utils';
import './RegistrationPage.css';
import { Section } from '../../utils/utils';
import AuthApiService from '../../services/auth-api-service';

export default class RegistrationForm extends Component {
  static defaultProps = {
    onRegistrationSuccess: () => {},
    // history: {
    //   push: () => {},
    // },
  }

  state = { error: null }
  
  handleSubmit = ev => {
    ev.preventDefault()
    const { full_name, nick_name, user_name, password } = ev.target

    this.setState({ error: null })
    AuthApiService.postUser({
      user_name: user_name.value,
      password: password.value,
      full_name: full_name.value,
      nickname: nick_name.value,
    })
      .then(user => {
        full_name.value = ''
        nick_name.value = ''
        user_name.value = ''
        password.value = ''
        this.props.onRegistrationSuccess()
      })
      .catch(res => {
        this.setState({ error: res.error })
      })
  }

  // handleRegistrationSuccess = user => {
  //   // const { history } = this.props
  //   this.props.history.push('/login')
  // }

  render() {
    const { error } = this.state
    return (
      <Section className="RegistrationPage">
        <form
          className='RegistrationForm'
          // onRegistrationSuccess={this.handleRegistrationSuccess}
          onSubmit={this.handleSubmit}
        >
          <div role='alert'>
            {error && <p className='red'>{error}</p>}
          </div>
          <div className='full_name'>
            <label htmlFor='RegistrationForm__full_name'>
              Full name <Required />
            </label>
            <Input
              name='full_name'
              type='text'
              required
              id='RegistrationForm__full_name'>
            </Input>
          </div>
          <div className='user_name'>
            <label htmlFor='RegistrationForm__user_name'>
              User name <Required />
            </label>
            <Input
              name='user_name'
              type='text'
              required
              id='RegistrationForm__user_name'>
            </Input>
          </div>
        <div className='password'>
            <label htmlFor='RegistrationForm__password'>
              Password <Required />
            </label>
            <Input
              name='password'
              type='password'
              required
              id='RegistrationForm__password'>
            </Input>
          </div>
          <div className='nick_name'>
            <label htmlFor='RegistrationForm__nick_name'>
              Nickname
            </label>
            <Input
              name='nick_name'
              type='text'
              required
              id='RegistrationForm__nick_name'>
            </Input>
          </div>
          <Button type='submit' className="register-button">
            Register
          </Button>
        </form>
      </Section>


    )
  }
}